import React from 'react';
import { useMsalAuth } from 'customHooks/useMsalAuth';
import { Redirect, Route } from 'react-router-dom';

const CustomSecureRoute = ({
	component: Component,
	children,
	...rest
}: {
	component?: React.ComponentType<any>;
	children?: React.ReactNode;
	[key: string]: any;
}) => {
	const { accounts } = useMsalAuth();

	return (
		<Route
			{...rest}
			render={(props) =>
				// Checks if user is logged in through msal
				accounts?.length ? (
					Component ? (
						<Component {...props} />
					) : (
						children
					)
				) : (
					<Redirect to="/login" />
				)
			}
		/>
	);
};

export default CustomSecureRoute;
